import { detectBrowser } from 'js/helpers/BrowserDetection';

export const LEVEL_ZOOM_THRESHOLD = detectBrowser().isChrome ? 8 : 10;
